import React from "react";
import "./../CoFilab.scss";
import dashboardIcon from "../../../images/settings-dashboard.svg";
import programIcon from "../../../images/settings-program.svg";
import { useNavigate } from "react-router-dom";
import BaseButton from "../../../components/UI/BaseButton/BaseButton";
import { Box } from "@mui/material";

function CoFiMarketplace() {
  //loop through the setting options to add it to the list of settings
  //will need to add url to the link to navigate to the correct page

  const navigate = useNavigate();
  const settingOptions = [
    {
      icon: dashboardIcon,
      option: "By Industry Vertical",
      description:
        "Find and Explore collaboration partnerships (by Country, Region and Industry)",
      link: "/remittance",
    },
    {
      icon: programIcon,
      option: "Search by Objectives",
      description:
        "Upload or link collaboration Datasets. All data will be securely stored in S3 bucket.",
      link: "/remittance",
    },
  ];

  const goBack = () => {
    navigate("/cofilab");
  };

  return (
    <Box className="page-container settings-container">
      <Box className="header-container">
        <Box className="settings-page-title">Collaborative Finance Lab</Box>
        <Box>
          Select the right partners based on Industry vertical and objectives.
        </Box>
      </Box>

      <Box className="settings-center-container">
        <Box className="row gap-3">
          {settingOptions.map((setting) => {
            return (
              <Box key={setting.option} className="settings-card col-3">
                <Box className="settings-card-title-container d-flex align-items-center">
                  <img src={setting.icon} alt={setting.option} loading="lazy" />
                  <Box className="settings-card-link" sx={{ color: "#5523D2",}}>{setting.option}</Box>
                </Box>
                <Box className="settings-card-body">{setting.description}</Box>
              </Box>
            );
          })}
        </Box>
        <Box className="return-button">
          <BaseButton
            buttonText={"Return to CoFi Lab"}
            onClick={goBack}
          ></BaseButton>
        </Box>
      </Box>
    </Box>
  );
}

export default CoFiMarketplace;
